import { jsonMember, jsonObject } from 'typedjson';
import { PublicCartBillingAddressRequest } from './public-cart-billing-address.request';
import { PublicCartShippingAddressRequest } from './public-cart-shipping-address.request';
import { Guid, Nillable } from '@web/utils';

@jsonObject
export class PublicCartCheckoutRequest {
  @jsonMember(Boolean)
  public readonly otherShippingAddress!: boolean;

  @jsonMember(Boolean)
  public readonly newsletter!: boolean;

  @jsonMember(String)
  public readonly shippingMethod!: Guid;

  @jsonMember(String)
  public readonly shippingPoint?: Nillable<string>;

  @jsonMember(String)
  public readonly paymentMethod!: Guid;

  @jsonMember(String)
  public readonly comment?: Nillable<string>;

  @jsonMember(PublicCartBillingAddressRequest)
  public readonly billingAddress!: PublicCartBillingAddressRequest;

  @jsonMember(PublicCartShippingAddressRequest)
  public readonly shippingAddress?: Nillable<PublicCartShippingAddressRequest>;

  public constructor(
    private readonly data: {
      newsletter: boolean;
      billingAddress: PublicCartBillingAddressRequest;
      comment?: Nillable<Guid>;
      otherShippingAddress: boolean;
      paymentMethod: Guid;
      shippingAddress?: Nillable<PublicCartShippingAddressRequest>;
      shippingMethod: Guid;
      shippingPoint?: Nillable<string>;
    },
  ) {
    this.newsletter = this.data.newsletter;
    this.billingAddress = this.data.billingAddress;
    this.comment = this.data.comment;
    this.otherShippingAddress = this.data.otherShippingAddress;
    this.paymentMethod = this.data.paymentMethod;
    this.shippingAddress = this.data.shippingAddress;
    this.shippingMethod = this.data.shippingMethod;
    this.shippingPoint = this.data.shippingPoint;
  }
}
